import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSwap(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M11 8a1 1 0 1 0 0 2h7.131l-.963 1.445a1 1 0 1 0 1.664 1.11L21.202 9l-2.37-3.555a1 1 0 0 0-1.664 1.11L18.13 8H11Zm2 8a1 1 0 1 0 0-2H5.868l.964-1.445a1 1 0 1 0-1.664-1.11L2.798 15l2.37 3.555a1 1 0 0 0 1.664-1.11L5.868 16H13Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
